import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneweekendtourpackage() {



    const cardData = {

keyword: "Pune Weekend Tour Packages",

headingDescription:
    "Rising Cab Service offers comfortable and affordable Pune Weekend Tour Packages for families, couples, friends, and corporate groups looking for a refreshing getaway. Our customized tour packages cover popular hill stations, historical forts, spiritual destinations, beaches, and wildlife attractions near Pune. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles with experienced drivers to ensure a safe and enjoyable journey. With flexible itineraries, transparent pricing, and 24/7 booking support, Rising Cab Service makes your weekend trip convenient and memorable.",

topPlaces: [
    {
        title: "Lonavala",
        description:
            "Lonavala is one of the most popular weekend destinations from Pune, known for its misty hills, lush valleys, waterfalls, and pleasant weather. Visitors can explore Tiger Point, Bhushi Dam, Rajmachi Fort, Karla Caves, and local markets famous for chikki and fudge. The hill station is perfect for family vacations, romantic trips, and adventure activities."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a scenic hill station famous for its strawberry farms, beautiful viewpoints, dense forests, and cool climate. Popular attractions include Arthur's Seat, Elephant's Head Point, Venna Lake, Wilson Point, and Mapro Garden. It is an ideal destination for nature lovers and weekend travelers."
    },
    {
        title: "Panchgani",
        description:
            "Panchgani is a charming hill station surrounded by five hills and picturesque valleys. The destination is known for Table Land, Sydney Point, Parsi Point, Devil's Kitchen, and scenic strawberry plantations. Its peaceful atmosphere makes it a favorite for short vacations."
    },
    {
        title: "Lavasa",
        description:
            "Lavasa is a planned hill city inspired by Italian architecture and surrounded by lakes and mountains. Visitors can enjoy boating, cycling, lakeside walks, water sports, and adventure activities while admiring the colorful buildings and scenic landscapes."
    },
    {
        title: "Bhimashankar",
        description:
            "Bhimashankar is a famous pilgrimage and nature destination known for the sacred Jyotirlinga Temple and wildlife sanctuary. Surrounded by the Sahyadri hills, the area offers spiritual experiences, trekking opportunities, and breathtaking natural beauty."
    },
    {
        title: "Matheran",
        description:
            "Matheran is India's smallest hill station and one of the few eco-sensitive destinations where motor vehicles are prohibited. The toy train, panoramic viewpoints, horse rides, and peaceful environment make it a unique weekend getaway from Pune."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a coastal town famous for its sandy beaches, sea forts, and relaxing atmosphere. Attractions such as Alibaug Beach, Kolaba Fort, Varsoli Beach, Kashid Beach, and Murud-Janjira Fort make it a perfect destination for beach lovers and family vacations."
    },
    {
        title: "Kaas Plateau",
        description:
            "Kaas Plateau, often called the Valley of Flowers of Maharashtra, is a UNESCO World Natural Heritage Site. During the monsoon season, the plateau blooms with hundreds of species of colorful wildflowers, attracting photographers, botanists, and nature enthusiasts."
    },
    {
        title: "Sinhagad Fort",
        description:
            "Sinhagad Fort is a historic Maratha fort located close to Pune and is famous for the bravery of Tanaji Malusare. The fort offers scenic trekking trails, panoramic views of the Sahyadri ranges, and authentic local cuisine, making it a popular weekend destination."
    },
    {
        title: "Kolad",
        description:
            "Kolad is an adventure tourism hotspot known for white-water rafting on the Kundalika River. The destination also offers kayaking, zip-lining, camping, trekking, and beautiful natural surroundings, making it an exciting choice for adventure seekers and weekend travelers."
    }
],



services: [
  {
    name: "Pune Weekend Tour Cab",
    description: "Rising Cab Service offers reliable Pune Weekend Tour Cab designed for comfortable, safe, and well-planned short trips from Pune to nearby destinations. Whether it’s a family outing, friends’ getaway, or couple trip, we provide clean AC vehicles, experienced drivers, flexible pickup timing, and 24x7 support to ensure a smooth and enjoyable weekend travel experience."
  },
  {
    name: "Pune Weekend Travel Packages",
    description: "Book Pune Weekend Travel Packages with Rising Cab Service for customized short holiday trips including hill stations, temples, beaches, and sightseeing destinations near Pune. Our packages include professional drivers, well-maintained vehicles, flexible itineraries, and budget-friendly pricing for a stress-free weekend escape."
  },
  {
    name: "Pune Weekend Trip Cab",
    description: "Our Pune Weekend Trip Cab service is perfect for short vacations and quick getaways from the city. We provide comfortable sedans, SUVs, and premium vehicles with experienced chauffeurs, ensuring safe travel, smooth highway rides, and complete flexibility for your weekend plans."
  },
  {
    name: "Pune Weekend Sightseeing Cab",
    description: "Rising Cab Service offers Pune Weekend Sightseeing Cab for exploring popular tourist spots around Pune with ease and comfort. Enjoy personalized sightseeing routes, door-to-door pickup, and flexible travel schedules designed for families, couples, and groups."
  },
  {
    name: "Pune Weekend Holiday Taxi",
    description: "Reliable Pune Weekend Holiday Taxi service for stress-free weekend travel plans. We ensure clean AC cars, professional drivers, and affordable packages for short holiday trips, making your weekend relaxing and memorable."
  },
  {
    name: "Pune Weekend Tour Service",
    description: "Rising Cab Service provides trusted Pune Weekend Tour Service with customized travel plans for nearby destinations. Whether it’s nature, pilgrimage, or leisure trips, we offer safe, comfortable, and well-organized weekend travel solutions."
  },
  {
    name: "Pune Weekend Outstation Cab",
    description: "Book Pune Weekend Outstation Cab for short-distance trips outside Pune with flexible one-way and round-trip options. Our service includes experienced drivers, clean vehicles, and budget-friendly pricing for weekend travel convenience."
  },
  {
    name: "Best Pune Weekend Packages Cab",
    description: "Choose Best Pune Weekend Packages Cab with Rising Cab Service for premium and well-planned weekend tours. We offer curated travel packages, comfortable vehicles, and professional service for a seamless travel experience."
  },
  {
    name: "Cheap Pune Weekend Cab",
    description: "Affordable Cheap Pune Weekend Cab service for budget travelers looking for economical weekend trips without compromising on safety and comfort. Enjoy low fares, reliable drivers, and clean vehicles for short getaways."
  },
  {
    name: "SUV Pune Weekend Trip Cab",
    description: "Book SUV Pune Weekend Trip Cab for group and family travel requiring extra space and comfort. Our SUVs are ideal for hill station trips, long drives, and weekend tours with smooth performance and professional drivers."
  },
  {
    name: "Innova Pune Weekend Tour Cab",
    description: "Premium Innova Pune Weekend Tour Cab service designed for families and groups seeking luxury and comfort during weekend trips. Enjoy spacious seating, smooth rides, and experienced chauffeurs for a premium travel experience."
  },
  {
    name: "Pune Weekend Getaway Taxi",
    description: "Reliable Pune Weekend Getaway Taxi service for quick escapes from city life. Perfect for short vacations, this service ensures comfortable travel, flexible routes, and safe driving for a relaxing weekend."
  },
  {
    name: "Pune Weekend Travel Cab",
    description: "Rising Cab Service offers Pune Weekend Travel Cab for all types of weekend journeys including sightseeing, hill stations, and nearby attractions with comfortable vehicles and professional drivers."
  },
  {
    name: "Pune Weekend Trip Booking Cab",
    description: "Easy Pune Weekend Trip Booking Cab system for instant reservations with multiple vehicle options. Enjoy quick confirmation, transparent pricing, and flexible travel planning for your weekend trips."
  },
  {
    name: "Pune Holiday Weekend Cab",
    description: "Comfortable Pune Holiday Weekend Cab service for planned holiday trips around Pune. We offer safe, reliable, and affordable travel solutions for families, couples, and groups."
  },
  {
    name: "Pune Weekend Tour Packages",
    description: "Rising Cab Service provides Pune Weekend Tour Packages with curated itineraries, comfortable vehicles, and professional drivers for a complete weekend travel experience."
  },
  {
    name: "Weekend Getaway from Pune",
    description: "Explore Weekend Getaway from Pune with customized cab services covering popular nearby destinations like Lonavala, Mahabaleshwar, Shirdi, and more for a refreshing break."
  },
  {
    name: "Pune Weekend Trip Package",
    description: "Book Pune Weekend Trip Package for well-planned short vacations with pickup, sightseeing, and return travel included in affordable and flexible packages."
  },
  {
    name: "Pune Weekend Holiday Package",
    description: "Pune Weekend Holiday Package offers complete travel solutions for relaxing weekend trips with comfortable cars, experienced drivers, and customized itineraries."
  },
  {
    name: "Pune Family Weekend Tour",
    description: "Comfortable Pune Family Weekend Tour service designed for safe and enjoyable family travel with spacious vehicles and flexible travel plans."
  },
  {
    name: "Pune Couple Weekend Package",
    description: "Romantic Pune Couple Weekend Package offering private and comfortable travel options for couples planning short getaways from Pune."
  },
  {
    name: "Pune Group Tour Package",
    description: "Pune Group Tour Package for friends, corporate teams, and large families with spacious vehicles like SUVs and Tempo Travellers for comfortable group travel."
  },
  {
    name: "Pune Weekend Sightseeing Tour",
    description: "Explore Pune Weekend Sightseeing Tour with guided travel options to popular attractions near Pune, ensuring a fun and relaxing weekend experience."
  },
  {
    name: "Pune Outstation Tour Package",
    description: "Rising Cab Service offers Pune Outstation Tour Package covering multiple destinations with flexible itineraries, professional drivers, and comfortable travel options."
  },
  {
    name: "Best Weekend Tours from Pune",
    description: "Discover Best Weekend Tours from Pune with curated travel packages to hill stations, beaches, and spiritual destinations for a perfect short vacation."
  }
],

tableData: [
  ["Pune Weekend Tour Cab", "Pune Weekend Travel Packages"],
  ["Pune Weekend Trip Cab", "Pune Weekend Sightseeing Cab"],
  ["Pune Weekend Holiday Taxi", "Pune Weekend Tour Service"],
  ["Pune Weekend Outstation Cab", "Best Pune Weekend Packages Cab"],
  ["Cheap Pune Weekend Cab", "SUV Pune Weekend Trip Cab"],
  ["Innova Pune Weekend Tour Cab", "Pune Weekend Getaway Taxi"],
  ["Pune Weekend Travel Cab", "Pune Weekend Trip Booking Cab"],
  ["Pune Holiday Weekend Cab", "Pune Weekend Tour Packages"],
  ["Weekend Getaway from Pune", "Pune Weekend Trip Package"],
  ["Pune Family Weekend Tour", "Pune Group Tour Package"]
],



whychoose: [
    {
        WhyChooseheading: "Exciting Pune Weekend Tour Packages",
        WhyChoosedescription: "Rising Cab Service offers well-planned Pune Weekend Tour Packages covering popular destinations, hill stations, beaches, forts, pilgrimage sites, and family-friendly attractions."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Every Group Size",
        WhyChoosedescription: "Our fleet includes Sedan cars, Ertiga, Innova Crysta, Tempo Travellers, and Mini Buses suitable for couples, families, friends, and corporate groups."
    },
    {
        WhyChooseheading: "Customized Weekend Travel Plans",
        WhyChoosedescription: "We provide flexible weekend tour packages that can be customized according to your preferred destination, travel duration, group size, and budget."
    },
    {
        WhyChooseheading: "Affordable Tour Packages",
        WhyChoosedescription: "Rising Cab Service offers cost-effective Pune weekend getaway packages with transparent pricing and complete travel convenience."
    },
    {
        WhyChooseheading: "Popular Destinations Covered",
        WhyChoosedescription: "Our weekend tours include Lonavala, Mahabaleshwar, Panchgani, Alibaug, Matheran, Lavasa, Shirdi, Bhimashankar, Tarkarli, Goa, and many other destinations."
    },
    {
        WhyChooseheading: "Professional Drivers for Safe Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, route expertise, punctual departures, and a comfortable travel experience throughout the tour."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "We provide convenient pickup services from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, and all major Pune locations."
    },
    {
        WhyChooseheading: "Perfect for Family and Group Trips",
        WhyChoosedescription: "Our Pune Weekend Tour Packages are ideal for families, friends, couples, corporate teams, students, and senior citizens seeking a memorable getaway."
    }
]
};

const faqData = [
    {
        question: "What are Pune Weekend Tour Packages?",
        answer: "Pune Weekend Tour Packages are short getaway travel plans designed for individuals, families, and groups looking to explore nearby tourist destinations over weekends."
    },
    {
        question: "Which destinations are included in weekend tour packages from Pune?",
        answer: "Popular destinations include Lonavala, Mahabaleshwar, Panchgani, Alibaug, Matheran, Lavasa, Shirdi, Bhimashankar, Goa, Tarkarli, and many more."
    },
    {
        question: "Do you provide customized weekend tour packages?",
        answer: "Yes, Rising Cab Service offers customized weekend tour packages based on destination preferences, travel duration, and budget."
    },
    {
        question: "Which vehicle options are available?",
        answer: "We provide Sedan cars, Ertiga, Innova Crysta, Tempo Travellers, Mini Buses, and luxury vehicles for weekend tours."
    },
    {
        question: "Can families book weekend tour packages?",
        answer: "Yes, our weekend tour packages are suitable for families, children, senior citizens, and group travelers."
    },
    {
        question: "Do you offer one-day and two-day tour packages?",
        answer: "Yes, we provide one-day, weekend, and multi-day tour packages from Pune."
    },
    {
        question: "Is hotel booking included in the package?",
        answer: "Hotel arrangements can be included upon request depending on the selected package."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, pickup and drop services are available from Pune Airport, Railway Station, hotels, and residential locations."
    },
    {
        question: "Are weekend tour packages available throughout the year?",
        answer: "Yes, our Pune Weekend Tour Packages are available year-round, including weekends, holidays, and festive seasons."
    },
    {
        question: "How can I book a Pune Weekend Tour Package?",
        answer: "You can book your package through phone, WhatsApp, or online booking with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Kunal Deshmukh",
        feedback:
            "Our Mahabaleshwar weekend trip was perfectly organized by Rising Cab Service. The vehicle was comfortable, the driver was professional, and the journey was enjoyable from start to finish.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Snehal Patil",
        feedback:
            "We planned a family weekend getaway through Rising Cab Service and had a fantastic experience. Clean vehicle, smooth travel, and excellent support throughout the tour.",
        rating: 5
    }
];




















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune Weekend Tour Packages",
"image": "https://www.risingcabservice.com/assets/images/pune-weekend-tour-packages.jpg",
"description": "Book Pune Weekend Tour Packages with Rising Cab Service for family trips, short vacations, sightseeing tours, and weekend getaways. Enjoy comfortable cabs, experienced drivers, and affordable travel packages for memorable holidays.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-weekend-tour-packages"
}
};





    return (
        <div>

<Helmet>
  <title>Pune Weekend Tour Packages | Weekend Getaway from Pune | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune Weekend Tour Packages for family vacations, weekend getaways, sightseeing tours, and short trips. Comfortable cabs, affordable packages, and professional drivers for a perfect weekend holiday."
/>

<meta
 name="keywords"
 content="pune weekend tour cab, pune weekend travel packages, pune weekend trip cab, pune weekend sightseeing cab, pune weekend holiday taxi, pune weekend tour service, pune weekend outstation cab, best pune weekend packages cab, cheap pune weekend cab, suv pune weekend trip cab, innova pune weekend tour cab, pune weekend getaway taxi, pune weekend travel cab, pune weekend trip booking cab, pune holiday weekend cab, Pune Weekend Tour Packages, Weekend Getaway from Pune, Pune Weekend Trip Package, Pune Weekend Holiday Package, Pune Weekend Tour Booking, Pune Short Trip Packages, Pune 2 Day Tour Package, Pune Family Weekend Tour, Pune Weekend Travel Package"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Puneweekendtourpackage;